import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type CharacteristicGroupsImportResult as SchemaCharacteristicGroupsImportResult } from '../schemas/CharacteristicGroupsImportResult';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @description Uploads an Excel file to update characteristic groups assignments
 * @tags Characteristics
 * @summary Import characteristic groups from Excel
 */
export const ImportCharacteristicGroupsContentType = 'multipart/form-data' as const;
export type ImportCharacteristicGroupsRequest = {
    /**
     * @format binary
     */
    file: string;
};
export type ImportCharacteristicGroupsResponses = LinkCommonErrorResponses & {
    /**
     * @description Groups imported successfully
     */
    '200': {
        'application/json': SchemaCharacteristicGroupsImportResult;
    };
};
export type ImportCharacteristicGroupsResponseSuccess = ImportCharacteristicGroupsResponses['200']['application/json'];
export type ImportCharacteristicGroupsSearchParams = undefined;
export type ImportCharacteristicGroupsPathParameters = undefined;
export const ImportCharacteristicGroupsUrl = '/characteristics/groups/import' as const;
export const ImportCharacteristicGroupsMethod = 'POST' as const;
export const getImportCharacteristicGroupsUrl = (_params?: ImportCharacteristicGroupsPathParameters) =>
    ImportCharacteristicGroupsUrl;
